'use client';

import { L2OrderBook, MarketType } from '@velocity-exchange/sdk';
import useMarketStateStore from '../stores/useMarketStateStore';
import { MarketId } from '@velocity-exchange/common';

const DEFAULT_L2_STATE: L2OrderBook = { asks: [], bids: [] };

const useL2StateForMarket = (
	marketIndex: number,
	marketType: MarketType
): L2OrderBook => {
	const l2State = useMarketStateStore((s) =>
		marketIndex === undefined || !marketType
			? DEFAULT_L2_STATE
			: s.getDlobStateForMarket(new MarketId(marketIndex, marketType))
	);

	return l2State;
};

export default useL2StateForMarket;
